import styled from "styled-components";
import { ProjectInfo } from "../ProjectInfo";

const Container = styled.div`
    width: 100%;
    height: 330px;
    border-radius: 25px;
    position: relative;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 8px 8px #adadad28;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    padding: 1.3rem;
    position: relative;
    text-align: center;
`;

const Title = styled.h2`
    font-family: ${({ theme }) => theme.fonts.sub};
    font-size: 1.5rem;
`;

const Summary = styled.p`
    font-family: ${({ theme }) => theme.fonts.sub};
    font-size: 1rem;
    margin-bottom: 15px;
`;

const ReadMoreButton = styled.button`
    display: flex;
    align-items: center;
    gap: 5px;
    background-color: white;
    
    font-size: large;
    font-weight: 600;

    font-size: 1rem;

    margin: auto auto 0 auto;

    padding: 10px 25px;

    border-radius: 5px;

    box-shadow: 0px 0px 10px 10px #96969622;

    transition: all 100ms;

    &:hover {
        color: ${({ color }) => color};
        cursor: pointer;
    }
`;

export function Project({ name, icon, color, summary, type, technologies, setProject, setIsModalOpen, githubUrl, description }) {
    return (
        <Container color={color}>
            <Content>
                {icon}
                <Title>
                    {name}
                </Title>
                <Summary>
                    {summary}
                </Summary>
                <ProjectInfo technologies={technologies} type={type} />
                <ReadMoreButton color={color} onClick={() => {
                        setProject({ name, color, summary, type, technologies, githubUrl, description });
                        setIsModalOpen(true);
                    }}>
                    LEIA MAIS
                </ReadMoreButton>
            </Content>
        </Container>
    )
}